import React, { useEffect, useRef } from 'react';
import './download-modal.scss';
import Button from 'src/components/Button';

interface CloseIconProps {
  width?: number;
  height?: number;
  className?: string;
}

const CloseIcon = ({
  width = 20,
  height = 20,
  className = '',
}: CloseIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M11.7816 4.03157C12.0062 3.80702 12.0062 3.44295 11.7816 3.2184C11.5571 2.99385 11.193 2.99385 10.9685 3.2184L7.50005 6.68682L4.03164 3.2184C3.80708 2.99385 3.44301 2.99385 3.21846 3.2184C2.99391 3.44295 2.99391 3.80702 3.21846 4.03157L6.68688 7.49999L3.21846 10.9684C2.99391 11.193 2.99391 11.557 3.21846 11.7816C3.44301 12.0061 3.80708 12.0061 4.03164 11.7816L7.50005 8.31316L10.9685 11.7816C11.193 12.0061 11.5571 12.0061 11.7816 11.7816C12.0062 11.557 12.0062 11.193 11.7816 10.9684L8.31322 7.49999L11.7816 4.03157Z"
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
      />
    </svg>
  );
};

interface DownloadModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDownloadCSV: () => void;
  onDownloadPDF: () => void;
}

const DownloadCSVModalLegacy = ({
  isOpen,
  onClose,
  onDownloadCSV,
  onDownloadPDF,
}: DownloadModalProps) => {
  const dialogContentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleMouseDown = (event: MouseEvent) => {
      if (
        dialogContentRef.current &&
        !dialogContentRef.current.contains(event.target as Node)
      ) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleMouseDown);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('mousedown', handleMouseDown);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="dialog-overlay">
      <div className="dialog-container">
        <div className="dialog-content" ref={dialogContentRef}>
          <div className="dialog-header">
            <div>
              <h2 className="dialog-title">Download CSV Overlay</h2>
              <p className="dialog-description">
                Refine your contact list with the options below
              </p>
            </div>
            <button
              className="dialog-close"
              onClick={onClose}
              aria-label="Close"
            >
              <CloseIcon />
            </button>
          </div>
          <div className="dialog-body">
            <div className="download-button-container">
              <Button
                color="teal"
                label="CSV download"
                size="tiny"
                onClick={onDownloadCSV}
              />
              <Button
                color="teal"
                label="PDF download"
                size="tiny"
                onClick={onDownloadPDF}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DownloadCSVModalLegacy;
